import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR
export function getSroiReportsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.sroiReportsPayload
  })
}
export function getSocialReturnOnInvestmentReportService({ id }) {
  return madeRequest('GET', {
    url: replaceRouteParams(ENDPOINTS.socialReturnOnInvestmentReport, {
      id
    })
  })
}

export function getSroiReportPayloadService({ id }) {
  return madeRequest('GET', {
    url: `${ENDPOINTS.sroiReportsPayload}${id}/`
  })
}

export function createSroiReportPayloadService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.sroiReportsPayload
  })
}

export function updateSroiReportPayloadService(id, data) {
  return madeRequest('PATCH', {
    data,
    url: `${ENDPOINTS.sroiReportsPayload}${id}/`
  })
}

export function deleteSroiReportPayloadService({ id }) {
  return madeRequest('DELETE', {
    url: `${ENDPOINTS.sroiReportsPayload}${id}/`
  })
}

export function getSroiInputsPresetService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.sroiInputsPreset
  })
}

export function updateSroiInputsPresetService(params, data) {
  return madeRequest('PATCH', {
    params,
    data,
    url: ENDPOINTS.sroiInputsPreset
  })
}
